import {
  AnimationTriggerMetadata,
  animate,
  keyframes,
  style,
  transition,
  trigger,
} from '@angular/animations';

const shakeIntensity = 4;
const shakeLeft = `translate3d(-${shakeIntensity}px, 0, 0)`;
const shakeRight = `translate3d(${shakeIntensity}px, 0, 0)`;
const smallShakeLeft = 'translate3d(-1px, 0, 0)';
const smallShakeRight = 'translate3d(-1px, 0, 0)';

export const formFieldAnimations: {
  readonly transitionMessages: AnimationTriggerMetadata;
  readonly controlErrorShake: AnimationTriggerMetadata;
} = {
  controlErrorShake: trigger('controlErrorShake', [
    transition('no-error => error', [
      animate(
        '1000ms ease-in',
        keyframes([
          style({ transform: smallShakeLeft, offset: 0.1 }),
          style({ transform: smallShakeRight, offset: 0.2 }),
          style({ transform: shakeLeft, offset: 0.3 }),
          style({ transform: shakeRight, offset: 0.4 }),
          style({ transform: shakeLeft, offset: 0.5 }),
          style({ transform: shakeRight, offset: 0.6 }),
          style({ transform: shakeLeft, offset: 0.7 }),
          style({ transform: smallShakeRight, offset: 0.8 }),
          style({ transform: smallShakeLeft, offset: 0.9 }),
        ]),
      ),
    ]),
  ]),
  transitionMessages: trigger('transitionMessages', [
    transition(':enter', [
      style({ opacity: 0, height: 0, transform: 'translateY(-5px)' }),
      animate('300ms cubic-bezier(0.55, 0, 0.55, 0.2)'),
    ]),
  ]),
};
